// extracted by mini-css-extract-plugin
module.exports = {"container":"TopicSection_container__2LH97","bannerContainer":"TopicSection_bannerContainer__HWL2s"};